<!--
 * @Description: 已购课程
 * @Author: xiawenlong
 * @Date: 2021-04-26 08:59:45
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-12-13 15:03:04
-->
<template>
  <div class="add-course-by-buy">
    <table-list
      title="课程列表"
      :loading="loading"
      :data="courseBuyList"
      :search-form="searchForm(this)"
      :columns="columns(this)"
      :btns="btns(this)"
      :pager="pager"
      :options="{
        selection: true,
        reserveSelection: true,
        rowKey: 'productId',
        selectable: selectEvent,
      }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '确认添加课程',
    method: _this.handleAdd,
    type: 'primary',
  },
]
// 搜索框配置
const searchForm = () => [
  {
    label: '课程名称',
    prop: 'keyword',
  },
  {
    label: '课程类型',
    type: 'select',
    prop: 'courseType',
    children: [
      { value: 0, label: '录播' },
      { value: 1, label: '直播' },
    ],
  },
  {
    label: '使用时间',
    type: 'picker',
    prop: 'createTime',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'pic',
    minWidth: 160,
    label: '课程封面',
    render: (h, { row }) => {
      return [
        row.pic
          ? h('img', {
              domProps: { src: row.pic },
              style: 'height: 50px',
            })
          : null,
      ]
    },
  },
  {
    prop: 'name',
    minWidth: 200,
    label: '课程名称',
  },
  {
    prop: 'courseType',
    minWidth: 100,
    label: '课程类型',
    formatter: row => {
      return { 0: '录播', 1: '直播', 9: '未知' }[row.courseType]
    },
  },
  {
    prop: 'teacherList',
    minWidth: 120,
    label: '任课老师',
    formatter: row => {
      if (row.teacherList.length) {
        let nameArray = row.teacherList.map(element => element.teacherName)
        return nameArray.join('，')
      } else {
        return ''
      }
    },
  },
  {
    prop: 'chapterCount',
    label: '章节数',
    minWidth: 100,
    align: 'right',
    sortable: true,
  },
  {
    prop: 'durationTotal',
    minWidth: 180,
    sortable: true,
    label: '课程总时长（分钟）',
    formatter: row => {
      return row.durationTotal
    },
  },
  {
    prop: 'buyMethodExplain',
    label: '购买方式',
    minWidth: 150,
  },
  {
    prop: 'availeDays',
    label: '可用天数（天）',
    align: 'right',
    sortable: true,
    minWidth: 150,
  },
]
import TableList from '@/components/TableList'
import { classCourseAddBuy, courseBuyList } from '@/api/class'
import to from 'await-to'
export default {
  name: 'CourseByBuy',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      loading: false,
      courseBuyList: [],
      selectCourse: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      queryParams: {},
    }
  },
  mounted() {
    this.getCourseBuy()
  },
  methods: {
    async getCourseBuy() {
      if (this.loading) return
      const { current, size } = this.pager
      const { classId } = this.$route.params
      this.loading = true
      const [res, err] = await to(courseBuyList({ classId, current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.courseBuyList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.createTime) {
        queryParams.startTime = queryParams.createTime[0]
        queryParams.endTime = queryParams.createTime[1]
      } else {
        queryParams.startTime = ''
        queryParams.endTime = ''
      }
      this.queryParams = queryParams
      this.getCourseBuy()
    },
    // 多选
    handleSelectionChange(val) {
      this.selectCourse = val
    },
    async handleAdd() {
      if (!this.selectCourse.length) return this.$message.warning('请先选择课程')
      const { classId } = this.$route.params
      const recordList = this.selectCourse.map(item => ({
        productId: item.productId,
        buyMethod: item.buyMethod,
      }))
      const [, err] = await to(classCourseAddBuy({ classId, recordList }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$router.push(`/class/addCourse/${classId}`)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getCourseBuy()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getCourseBuy()
    },
    selectEvent(row) {
      return !row.flag
    },
  },
}
</script>
<style lang="scss" scoped>
.add-course-by-buy {
  ::v-deep.table-list {
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      display: none;
    }
  }
}
</style>
